import { render, staticRenderFns } from "./according-install.vue?vue&type=template&id=141fc966&scoped=true&"
import script from "./according-install.vue?vue&type=script&lang=js&"
export * from "./according-install.vue?vue&type=script&lang=js&"
import style0 from "./according-install.vue?vue&type=style&index=0&id=141fc966&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141fc966",
  null
  
)

export default component.exports